import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import {downloadOrderCalendarEvent} from '../../services/calendarEventService';

const {FiDownload}=FiIcons;

const STATUS_STYLES = {
  pending: 'border-amber-200 bg-amber-50 text-amber-800',
  accepted: 'border-blue-200 bg-blue-50 text-blue-800',
  preparing: 'border-violet-200 bg-violet-50 text-violet-800',
  ready: 'border-emerald-200 bg-emerald-50 text-emerald-800',
  completed: 'border-green-200 bg-green-50 text-green-800',
  declined: 'border-red-200 bg-red-50 text-red-800',
  cancelled: 'border-slate-200 bg-slate-100 text-slate-700'
};

const SellerCalendarOrder = ({ order, onSelect }) => (
  <div>
    <button
      type="button"
      onClick={() => onSelect(order)}
      className={`w-full rounded-lg border px-2 py-1.5 text-left transition hover:-translate-y-0.5 hover:shadow-sm ${
        STATUS_STYLES[order.status] || 'border-gray-200 bg-gray-50 text-gray-700'
      }`}
      title={`${order.requested_time || 'Time not set'} · ${order.buyer?.name || 'Customer'} · ${order.status}`}
    >
      <span className="block truncate text-[10px] font-black uppercase tracking-wide">
        {order.requested_time || 'Time not set'}
      </span>
      <span className="mt-0.5 block truncate text-xs font-bold">
        {order.buyer?.name || 'Customer'}
      </span>
      <span className="block truncate text-[9px] font-black uppercase tracking-wider opacity-70">
        {order.status}
      </span>
    </button>
    {order.status === 'accepted' && order.requested_date && (
      <button
        type="button"
        onClick={() => downloadOrderCalendarEvent(order)}
        className="mt-1 flex w-full items-center justify-center gap-1 rounded-md border border-slate-200 bg-white px-2 py-1 text-[9px] font-black uppercase tracking-wide text-slate-600 transition hover:border-indigo-200 hover:text-indigo-600"
        aria-label="Download calendar event for accepted order"
      >
        <SafeIcon icon={FiDownload} />
        Add to calendar
      </button>
    )}
  </div>
);

export default SellerCalendarOrder;
